import * as React from "react";
import styled from "styled-components"

import TextInput from 'src/SharedComponents/TextInput';

interface IProps {
    day: string,
    month: string,
    year: string,
    DayChanged: (e: React.SyntheticEvent<HTMLInputElement>) => void,
    MonthChanged: (e: React.SyntheticEvent<HTMLInputElement>) => void,
    YearChanged: (e: React.SyntheticEvent<HTMLInputElement>) => void,
    invalid?: boolean,
    enterPressed?: () => void
}

const DateOfBirthContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    margin: 24px 0 12px;
`;

const DateOfBirthInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1 1 auto;
`;

const DateInput = (props: IProps) => {
    const {
        day,
        month,
        year,
        DayChanged,
        MonthChanged,
        YearChanged,
        invalid
    } = props;

    return <DateOfBirthContainer>
        <DateOfBirthInputContainer>
            <TextInput ariaLabel="Date of birth" invalid={invalid} value={day} onChange={DayChanged} label="DD" min={1} max={31} type="number" width="48px" margin="0 5px 0 0" />
            <TextInput ariaLabel="Month of birth" invalid={invalid} value={month} onChange={MonthChanged} label="MM" min={1} max={12} type="number" width="52px" margin="0 5px" />
            <TextInput ariaLabel="Year of birth" invalid={invalid} value={year} onChange={YearChanged} label="YYYY" min={1900} max={2099} type="number" width="72px" margin="0 5px" />
        </DateOfBirthInputContainer>
    </DateOfBirthContainer>
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/SharedComponents/DateInput.tsx